import React from "react";
import styled from "styled-components";
import { AgencyXLogo, AbbvieLogo, ClonmelHealthcareLogo } from "images/svgs";

const Footer = () => {
  return (
    <Container>
      <p>
        Kindly supported by AbbVie
        <br />
        <br />
        All content and views expressed are those of the <br />
        speakers and not those of the sponsor
      </p>
      <a href="https://www.abbvie.ie/" target="blank">
        <AbbvieLogo />
      </a>
      <div>
        <a href="https://agencyx.ie" target="blank">
          <AgencyXLogo />
        </a>
        <span>
          This AX Engage Livestream is
          brought to you by Agency X.
        </span>
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 1442px;
  padding: 2rem 1.5rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  background: white;
  align-items: center;
  position: relative;
  z-index: 10;
  gap: 1rem;
  a {
    height: 100%;
    width: 100%;
    justify-self: center;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    &:first-of-type {
      max-width: 80px;
      justify-self: start;
      padding: 1rem 0;
    }
    &:nth-of-type(2) {
      max-width: 60px;
      justify-self: end;
    }
  }
  p {
    font-family: "League Spartan", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1rem;
    grid-column: 1 / 4;
    text-align: center;
  }
  div {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 0.5rem;
    span {
      text-align: right;
      font-size: 0.6rem;
      line-height: 0.875rem;
      max-width: 200px;
      margin-left: auto;
    }
    a {
      max-width: 100% !important;
      padding: 0 !important;
      justify-content: flex-end;
      svg {
        max-width: 120px;
      }
    }
  }
  @media (min-width: 768px) {
    padding: 2rem 3rem 3rem 3rem;
    grid-template-columns: 1fr 1fr 1fr;
    p {
      font-size: 1.25rem;
      line-height: 1.5rem;
    }
    a {
      &:first-of-type {
        max-width: 142px;
        justify-self: center;
      }
      &:nth-of-type(2) {
        max-width: 100px;
        justify-self: center;
      }
    }
    div {
      span {
        font-size: 0.875rem;
        line-height: 1rem;
      }
      a {
        svg {
          max-width: 148px;
        }
      }
    }
  }
  @media (min-width: 1150px) {
    padding: 3rem 4rem;
    grid-template-columns: 2fr 1fr 2fr;
    a {
      align-items: center;
    }
    p {
      text-align: left;
      grid-column: 1 / span 1;
    }
  }
`;

export default Footer;
